import { useContext, useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { UserContext } from "../userContext"
import Spinner, { ToggleSpinner } from "../components/spinner"
import "../../styles/text.css"
import { fetchResource } from "../../methods/fetchResource"
import { generateErrorMessage } from "../../methods/generateErrorMessage"

export default function Home() {
	const [message, setMessage] = useState("")
	const [searchParams] = useSearchParams()
	const userContext = useContext(UserContext)
	const navigate = useNavigate()

	function setMessageAndHideSpinner(message) {
		ToggleSpinner("spinner")
		setMessage(message)
	}

	useEffect(() => {
		async function processParcelID(parcelID) {
			await fetchResource(`/api/home`, {
				parcelID
			})

			//Check to make sure we have a good parcel ID
			let parcelStatus = await fetchResource(`/api/parcelStatus?parcelID=${parcelID}`)

			if (!parcelStatus.success) {
				setMessageAndHideSpinner(generateErrorMessage(parcelStatus.status))
				return
			}

			if (parcelStatus.result.status) {
				setMessageAndHideSpinner(generateErrorMessage(90))
				return
			}

			let partialExemption = await fetchResource(`/api/partialExemption?parcelID=${parcelID}`)

			if (!partialExemption.success) {
				setMessageAndHideSpinner(generateErrorMessage(partialExemption.status))
				return
			}

			if (partialExemption.result.rows.length > 0) {
				setMessageAndHideSpinner("Sorry, we cannot process exemptions online for this property due to the current ownership status. Please call our office at (850) 983-1880 for more information or visit our office to apply for exemptions.")
				return
			}

			let streetAddress = await fetchResource(`/api/situsAddress?parcelID=${userContext.parcelID}`)

			if (streetAddress.success) {
				userContext.situsAddress = streetAddress.result.address2
			}

			//Pull HX Code and store in User Context            
			let existingExemptions = await fetchResource(`/api/existingExemptions?parcelID=${parcelID}`)

			if (!existingExemptions.success) {
				setMessageAndHideSpinner(generateErrorMessage(existingExemptions.status))
				return
			}

			let hxExemption = existingExemptions.result.rows.find(element => element.exemption_code.trim() === "HX")

			userContext.parcelHasHxCode = hxExemption ? true : false
			userContext.user_is_homestead = hxExemption ? true : false

			//See if we can bypass residency check now so we don't have to later
			/*let ownerList = await fetchResource(`/api/ownerList?parcelID=${parcelID}`)

			if (ownerList.success) {
				for (let i = 0; i < ownerList.result.rows.length; i++) {
					let checkForBypass = await fetchResource(`/api/hxApplicationCompleted?parcelID=${parcelID}&name=${encodeURIComponent(ownerList.result.rows[i].name.trim())}`)

					if (checkForBypass.success) {
						if (checkForBypass.result.completed) {
							userContext.bypassResidencyDueToApplication = true
						}
					}
				}
			}*/

			//Does a record exist?
			let recordExists = await fetchResource(`/api/applicantRecordExists?parcelID=${parcelID}`)

			if (recordExists === null) {
				setMessageAndHideSpinner(generateErrorMessage(recordExists.status))
				return
			}

			//Account exists, redirect to login
			if (recordExists.result.record_exists) {
				navigate("/login")
				return
			}

			//Send to Register if Homestead or they just completed hx
			if (userContext.parcelHasHxCode || userContext.bypassResidencyDueToApplication) {
				navigate("/register")
				return
			}

			//Send to Online Eligibility if no Homestead
			let promptForBuilding = false
			if (searchParams.get("promptForBuilding") !== null && typeof searchParams.get("promptForBuilding") === "string") {
				promptForBuilding = searchParams.get("promptForBuilding").toLowerCase()
			}

			navigate(`/onlineEligibility?promptForBuilding=${promptForBuilding}`)
		}

		ToggleSpinner("spinner")

		userContext.parcelID = searchParams.get("parcelID")

		if (userContext.parcelID === null) {
			setMessageAndHideSpinner("Please navigate to this page from your parcel")
			return
		}

		processParcelID(userContext.parcelID)
	}, [navigate, searchParams])

	useEffect(() => {
		if (message !== "") {
			document.getElementById("homeRouteMessage").classList.remove("hide-message")
			return
		}

		document.getElementById("homeRouteMessage").classList.add("hide-message")
	}, [message])

	return (
		<div id="exemptions-portal--home" className="container">
			<div className="row">
				<div className="col-12">
					<Spinner id="spinner" />
					<h1 id="homeRouteMessage" className="h1-style">
						{message}
					</h1>
				</div>
			</div>
		</div>
	)
}